import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#254B5A',
    },
    secondary: {
      main: '#8BB83A',
    },
  },
  typography: {
    fontFamily: 'Nunito, Arial, sans-serif',
    button: {
      fontSize: '12px',
      lineHeight: '90%',
    },
  },
} as const);

const customPalette = {
  accent: {
    main: '#00223C',
    blue: '#99BAE3',
    defaultGreen: '#8BB83A',
    white: '#ffffff',
  },
  grey: {
    main: '#323F4B',
    800: '#323F4B',
    400: '#7B8794',
    300: '#9AA5B1',
    200: '#CBD2D9',
    100: '#E3E7EB',
    50: '#f0f4f8',
    0: '#F5F7FA',
    dark: '#171D23',
  },
  positive: {
    main: '#6A983C',
    600: '#6A983C',
    400: '#8C9C56',
    300: '#80A539',
    200: '#97B053',
    100: '#C0D120',
  },
  negative: {
    main: '#B00000',
    600: '#B00000',
    400: '#C54545',
    200: '#E28585',
    100: '#FFCECE',
  },
  warning: {
    main: '#775E00',
    600: '#775E00',
    400: '#CBA328',
    200: '#D3A914',
    100: '#F9DDAF',
  },
  blue: {
    main: '#007EC3',
  },
};

export { theme, customPalette };
